
export default {
    props: ['count'],
}
